import { useRef, useState } from "react";
import { Camera } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const Upload = ({ url, onDone, label, testId, capture = "user", className = "" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post(url, fd, { headers: { "Content-Type": "multipart/form-data" } });
      onDone(data.url);
      toast.success("അപ്‌ലോഡ് ചെയ്തു");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); e.target.value = ""; }
  };
  return (<>
    <input ref={ref} type="file" accept="image/*" capture={capture} className="hidden" onChange={pick} data-testid={`${testId}-input`} />
    <button type="button" data-testid={testId} disabled={busy} onClick={() => ref.current?.click()} className={`btn-ghost rounded-full h-9 px-4 text-xs font-semibold inline-flex items-center gap-1.5 disabled:opacity-50 ${className}`}><Camera size={13} /> {busy ? "അപ്‌ലോഡ്..." : label}</button>
  </>);
};

export const StarRater = ({ onRate, testId = "star-rater" }) => {
  const [v, setV] = useState(0);
  return (
    <div data-testid={testId} className="flex items-center justify-center gap-1">
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" data-testid={`${testId}-${n}`} onClick={() => { setV(n); onRate(n); }} className={`text-3xl transition-transform hover:scale-110 ${n <= v ? "text-[var(--gold)]" : "text-slate-300"}`}>★</button>
      ))}
    </div>
  );
};
